import {
  Avatar,
  Button,
  Checkbox,
  Flex,
  Icon,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Stack,
  Badge,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { FaEdit, FaTrash, FaArchive } from "react-icons/fa";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

function ProductTable(props) {
  const { columnsData, tableData, onEdit, onDelete } = props;
  const transformedProductData = useMemo(() => {
    if (!Array.isArray(tableData)) return [];

    return tableData.map((product) => ({
      productName: product?.name ?? "N/A",
      productId: product?.productId ?? "N/A",
      price: product?.price ?? 0,
      measurementType: product?.measurementType ?? "N/A",
      quantityType: product?.quantityType ?? "N/A",
      allowedQuantities: product?.allowedQuantities ?? "N/A",
      status: product?.status ? "Ενεργό" : "Ανενεργό", 
      createdAt: new Date(product?.createdAt).toLocaleDateString(),
      updatedAt: new Date(product?.updatedAt).toLocaleDateString(),
      original: product, // keep original data for edit/delete actions
    }));
  }, [tableData]);
  const productColumns = [
    {
      Header: "ΑΡ. ΠΡΟΪΌΝΤΟΣ",
      accessor: "productId",
    },
    {
      Header: "ΟΝΟΜΑΣΙΑ",
      accessor: "name",
    },

    {
      Header: "ΚΟΣΤΟΣ / ΜΟΝ. ΜΕΤΡ.",
      accessor: "price",
      Cell: ({ value }) => {
        const price = Number(value ?? 0);
        const formatted = new Intl.NumberFormat("el-GR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(price);

        return `€${formatted}`;
      },
    },

    {
  Header: "ΜΟΝ. ΜΕΤΡΗΣΗΣ",
  accessor: "measurementType",
  Cell: ({ value }) => {
    const unitTypeToGreek = {
      BOXES: "ΚΟΥΤΕΣ",
      PIECES: "ΤΜΧ",
      KGS: "ΚΙΛΑ",
    };
    return unitTypeToGreek[value] || value;
  },
},

     {
            Header: "ΚΑΤΑΣΤΑΣΗ",
            accessor: "status",
            Cell: ({ value }) => {
              const isActive = value === true || value === "true" || value === 1;
              return (
                <Badge
                  colorScheme={isActive ? "teal" : "red"}
                  variant="subtle"
                  borderRadius="full"
                  px={3}
                  py={1}
                >
                  {isActive ? "Ενεργό" : "Ανενεργό"}
                </Badge>
              );
            },
          },
    // {
    //   Header: "Quantity Type",
    //   accessor: "quantityType",
    // },
    // {
    //   Header: "Allowed Quantities",
    //   accessor: "allowedQuantities",
    // },
    // {
    //   Header: "Status",
    //   accessor: "status",
    // },
    // {
    //   Header: "Created At",
    //   accessor: "createdAt",
    // },
    // {
    //   Header: "Updated At",
    //   accessor: "updatedAt",
    // },
  ];

  const columns = useMemo(
    () => [
      ...productColumns,
      // {
      //     Header: "Action",
      //     accessor: "action",
      //     Cell: ({ row }) => (
      //         <Flex gap={3}>
      //             <Icon
      //                 as={FaEdit}
      //                 color="blue.500"
      //                 cursor="pointer"
      //                 w="20px"
      //                 h="20px"
      //                 onClick={(e) => {
      //                     e.stopPropagation();
      //                     onEdit(row.original);
      //                 }}
      //             />

      //             {/* <Icon
      //                 as={FaArchive}
      //                 color="orange.500"
      //                 cursor="pointer"
      //                 w="20px"
      //                 h="20px"
      //                 onClick={(e) => {
      //                     e.stopPropagation();
      //                     onDelete(row.original);
      //                 }}
      //             /> */}

      //         </Flex>
      //     ),
      // },
    ],
    [columnsData, onEdit, onDelete]
  );

  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const createPages = (count) => {
    let arrPageCount = [];

    for (let i = 1; i <= count; i++) {
      arrPageCount.push(i);
    }

    return arrPageCount;
  };

  const {
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    state,
    getTableProps,

    gotoPage,
    pageCount,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
  } = tableInstance;
  const { pageIndex, pageSize, globalFilter } = state;

  return (
    <Flex
      direction="column"
      w="100%"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex
        align={{ sm: "flex-start", lg: "flex-end" }}
        justify={{ sm: "flex-start", lg: "flex-end" }}
        w="100%"
        px="22px"
        mb="36px"
      >
        <Input
          type="text"
          placeholder="Αναζήτηση…"
          minW="75px"
          maxW="175px"
          fontSize="sm"
          _focus={{ borderColor: "teal.300" }}
          onChange={(e) => setGlobalFilter(e.target.value)}
        />
      </Flex>

      <Flex overflowX="auto">
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead position="sticky" top="0" zIndex="1" bg="white">
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={index}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize="12px"
                      color="gray.400"
                    >
                      {column.render("Header")}
                      <Icon
                        w="14px"
                        h="14px"
                        color={column.isSorted ? "gray.500" : "gray.400"}
                        as={
                          column.isSorted
                            ? column.isSortedDesc
                              ? TiArrowSortedDown
                              : TiArrowSortedUp
                            : TiArrowUnsorted
                        }
                      />
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr
                  {...row.getRowProps()}
                  key={index}
                  cursor="pointer"
                  _hover={{ bg: "gray.100" }}
                  onClick={() => onEdit(row.original)}
                >
                  {row.cells.map((cell, index) => (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize="14px"
                      minW="150px"
                    >
                      {cell.render("Cell")}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Flex>
      <Flex
        direction={{ sm: "column", md: "row" }}
        justify="space-between"
        align="center"
        px="22px"
        w="100%"
        px={{ md: "22px" }}
      >
        <Text
          fontSize="sm"
          color="gray.500"
          fontWeight="normal"
          mb={{ sm: "24px", md: "0px" }}
        >
          Showing {pageSize * pageIndex + 1} to{" "}
          {pageSize * (pageIndex + 1) <= tableData.length
            ? pageSize * (pageIndex + 1)
            : tableData.length}{" "}
          of {tableData.length} entries
        </Text>
        <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
          <Button
            variant="no-hover"
            onClick={() => previousPage()}
            transition="all .5s ease"
            w="40px"
            h="40px"
            borderRadius="50%"
            bg="#fff"
            border="1px solid lightgray"
            display={
              pageSize === 5 ? "none" : canPreviousPage ? "flex" : "none"
            }
            _hover={{
              bg: "gray.200",
              opacity: "0.7",
              borderColor: "gray.500",
            }}
          >
            <Icon as={GrFormPrevious} w="16px" h="16px" color="gray.400" />
          </Button>
          {pageSize === 5 ? (
            <NumberInput
              max={pageCount - 1}
              min={1}
              w="75px"
              mx="6px"
              defaultValue="1"
              onChange={(e) => gotoPage(e)}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper onClick={() => nextPage()} />
                <NumberDecrementStepper onClick={() => previousPage()} />
              </NumberInputStepper>
            </NumberInput>
          ) : (
            createPages(pageCount).map((pageNumber, index) => {
              return (
                <Button
                  variant="no-hover"
                  transition="all .5s ease"
                  onClick={() => gotoPage(pageNumber - 1)}
                  w="40px"
                  h="40px"
                  borderRadius="160px"
                  bg={pageNumber === pageIndex + 1 ? "teal.300" : "#fff"}
                  border="1px solid lightgray"
                  _hover={{
                    bg: "gray.200",
                    opacity: "0.7",
                    borderColor: "gray.500",
                  }}
                  key={index}
                >
                  <Text
                    fontSize="xs"
                    color={pageNumber === pageIndex + 1 ? "#fff" : "gray.600"}
                  >
                    {pageNumber}
                  </Text>
                </Button>
              );
            })
          )}
          <Button
            variant="no-hover"
            onClick={() => nextPage()}
            transition="all .5s ease"
            w="40px"
            h="40px"
            borderRadius="160px"
            bg="#fff"
            border="1px solid lightgray"
            display={pageSize === 5 ? "none" : canNextPage ? "flex" : "none"}
            _hover={{
              bg: "gray.200",
              opacity: "0.7",
              borderColor: "gray.500",
            }}
          >
            <Icon as={GrFormNext} w="16px" h="16px" color="gray.400" />
          </Button>
        </Stack>
      </Flex>
    </Flex>
  );
}

export default ProductTable;
